import WithdrawalQueContainer from 'containers/Ques/Withdrawal'
import React from 'react'

const WithdrawalQuePage = () => <WithdrawalQueContainer />

export default WithdrawalQuePage
